import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router';
import { Spinner } from 'components/common/Spinner';
import { UserProvider } from 'components/contexts/UserContext';
import AppServices from 'services/AppServices';
import Layout from 'components/common/Layout';

export enum PrivateRouteType {
	Undefined
}

interface PrivateRouteProps extends RouteProps {
	type?: PrivateRouteType;
}

interface PrivateRouteState {
	refreshing: boolean;
	loggedin: boolean;
}

export class PrivateRoute extends React.Component<PrivateRouteProps, PrivateRouteState>
{
	constructor(props: PrivateRouteProps) {
		super(props);
		this.state = { refreshing: true, loggedin: false }
		this.updateSessionData = this.updateSessionData.bind(this);
	}

	componentDidMount() {
		this.updateSessionData();
	}

	// UNSAFE_componentWillReceiveProps() {
	// 	this.setState({ refreshing: true, loggedin: false });
	// 	this.updateSessionData();
	// }

	updateSessionData() {
		console.debug('Refreshing session data now')
		AppServices.loginService.verifySession()
			.then(result => {
				if (result === true) {
					return UserProvider.refresh()
						.catch(reason => false);
				}
				return result;
			})
			.then(result => this.setState({ refreshing: false, loggedin: result }))
	}

	render() {
		if (this.state.refreshing === false) {
			if (this.state.loggedin === true) // User is logged in
			{
				return <Route {...this.props} />;
			}
			else {
				// User is not logged in, redirect to login page
				return <Redirect to={{ pathname: '/login', state: { referrer: this.props.path } }} />;
			}
		}
		else
			return <Layout><Spinner /></Layout>; // Not sure yet
	}
}
